import { render, staticRenderFns } from "./BoxesItem.vue?vue&type=template&id=6af2ddb0&"
import script from "./BoxesItem.vue?vue&type=script&lang=js&"
export * from "./BoxesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/toastgroup.no/toastgroup.no/wp-content/themes/toastgroup/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af2ddb0')) {
      api.createRecord('6af2ddb0', component.options)
    } else {
      api.reload('6af2ddb0', component.options)
    }
    module.hot.accept("./BoxesItem.vue?vue&type=template&id=6af2ddb0&", function () {
      api.rerender('6af2ddb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/front/js/compontents/filters/select/BoxesItem.vue"
export default component.exports